import React from 'react'
import { TextFieldFormsy } from '@fuse'
import { Icon, InputAdornment, IconButton } from '@material-ui/core'
import { usePassword } from 'app/componentV4/usePassword'

export default (props) => {
  const { showPassword, onSwitchShowPassword } = usePassword()
  return (
    <TextFieldFormsy
      {...props}
      type={showPassword ? 'text' : props.type}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              className="p-0"
              aria-haspopup="true"
              onClick={onSwitchShowPassword}
            >
              <Icon className="text-20" color="action">
                {showPassword ? 'visibility' : 'visibility_off'}
              </Icon>
            </IconButton>
          </InputAdornment>
        ),
      }}
      variant="outlined"
      required
    />
  )
}
